import { Stack } from "@mui/material";
import SpacialSla from "components/customer-information/preferences/spacialSla/SpacialSla";
import { PageTitle } from "components/shared";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { preferencesTypeIds } from "utils/constants/customer-information/CustomerPreference";

const SpacialSlaMain = () => {
    const location = useLocation();
    const {
        rowdata,
    } = location.state || {};
    return (
        <>
            <Stack>
                <PageTitle title={`${t(`preferences.spacialSla.title.${rowdata.preference_type_id ? rowdata.preference_type_id : preferencesTypeIds.criticalSpacialSla}`)}`} />
                <SpacialSla />
            </Stack>
        </>
    );
};

export default SpacialSlaMain;
